"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var BadgeButton = function BadgeButton(_ref) {
  var active = _ref.active,
      onClick = _ref.onClick,
      title = _ref.title,
      count = _ref.count,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["active", "onClick", "title", "count", "className"]);

  var classNames = className + " btn " + (active ? "btn-primary" : "btn-light");
  return _react["default"].createElement("button", _extends({
    name: "badge-button",
    type: "button",
    className: classNames,
    onClick: onClick
  }, rest), title, " ", _react["default"].createElement("span", {
    className: "badge badge-light"
  }, count));
};

BadgeButton.propTypes = {
  /** if the badge button is disabled */
  active: _propTypes["default"].bool.isRequired,

  /** function for the click */
  onClick: _propTypes["default"].func.isRequired,

  /** title of the button */
  title: _propTypes["default"].string.isRequired,

  /** count for the counter */
  count: _propTypes["default"].number.isRequired,

  /** class name to pass to the button */
  className: _propTypes["default"].string
};
BadgeButton.defaultProps = {
  className: ""
};
var _default = BadgeButton;
exports["default"] = _default;